import { gql } from '@apollo/client';

export const GET_SPLIT_SCREEN_TEMPLATES = gql`
  query GetSplitScreenTemplates {
    getSplitScreenTemplates {
      _id
      name
      img
      templateConfig
      screenZones
      orientation
      editorOrientation
      category
      template
      templateId
      isHide
      listOrder
    }
  }
`;

// Video-wall flavour of the same `split-screen-templates` collection.
// Backend filters by `template === 'videoWallTemplate'` + `isHide !== true`,
// sorts by `category` asc (the "2 Screens" / "3 Screens" / "4 Screens" tab
// grouping) then `listOrder` desc within a category. The `template` field
// is intentionally omitted from the projection — every result is by
// definition a video-wall template, and exposing the string value through
// a Boolean GraphQL field would coerce to `true` (not useful + confusing).
export const GET_VIDEO_WALL_TEMPLATES = gql`
  query GetVideoWallTemplates {
    getVideoWallTemplates {
      _id
      name
      img
      templateConfig
      screenZones
      orientation
      editorOrientation
      category
      templateId
      isHide
      listOrder
    }
  }
`;

export const VALIDATE_SPLIT_SCREEN_SCHEDULE_CONFLICT = gql`
  query ValidateSplitScreenScheduleConflict($assetId: String!, $screenZones: JSON) {
    validateSplitScreenScheduleConflict(assetId: $assetId, screenZones: $screenZones)
  }
`;
